import React, {Component} from 'react';
import {NavLink} from 'react-router-dom'

import {BASE_PATH} from "../../../../../wpconfig";

class RederItem extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const record = this.props.record;
		return (
			<tr>
				<td className="">{this.props.no}</td>
				<td className="text-left">
					<div className="document-list-item pt-1 pb-1">
						{record.doi ?
						<a href={"https://doi.org/" + record.doi} target="_blank"
						         className="text-left">{record.meta}</a>
							: record.meta }
					</div>
				</td>
			</tr>
		)
	}
}

export default RederItem;

// Resources.propTypes = {
//     monitor_box_status: PropTypes.bool,
//     listStatus: PropTypes.array,
//     id: PropTypes.string,
//     companyStatus: PropTypes.string,
//     companyName: PropTypes.string,
//     address: PropTypes.string,
//     reportID: PropTypes.string,
//     isUserList: PropTypes.string,
//     createDate: PropTypes.string,
//     startDate: PropTypes.string,
//     endDate: PropTypes.string,
//     advertiserName: PropTypes.string,
//     advertiserPhone: PropTypes.string,
//     operatorPhone: PropTypes.string,
//     operatorName: PropTypes.string,
//     reportKeywords: PropTypes.array,
//     monitoringInfo: PropTypes.string,
// };
